import styled from 'styled-components';

export const Container = styled.div`
    width: 100%;
    height: 100%;
    flex: 1;
    color: #fff;
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: stretch;
`;

export const Listing = styled.div`
    width: 100%;
    flex: 1;
    color: #fff;
    padding: 20px 0;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: stretch;
`;

export const ButtonRow = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: stretch;
    justify-content: stretch;
`;

export const Button = styled.div`
    flex: 1;
    height: 30px;
    background-color: transparent;
    border: 1px solid ${props => props.color};
    color: ${props => props.color};
    transition: all .4s ease 0s;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    :hover:not(.disabled) {
        background-color: ${props => props.color};
        color: #000;
    }

    &:not(:first-child) {
        margin-left: 10px;
    }

    &.disabled {
        opacity: 0.4;
        cursor: default;
    }
`;

export const AudioItems = styled.div`
    width: 100%;
    display: flex;
    flex: 1;
    flex-direction: column;
    align-items: flex-start;
    justify-content: stretch;
    margin-bottom: 10px;
`;

export const Item = styled.div`
    width: 100%;
    height: 50px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: stretch;

    :hover {
        background-color: #333;
    }
`;

export const AudioName = styled.div`
    flex: 1;
    color: #fff;
    font-size: 14px;
    padding-left: 10px;
`;

export const AudioPlay = styled.div`
    width: 30px;
    height: 30px;
    position: relative;
    cursor: pointer;
    border: 1px solid #fc0;
    margin-left: 10px;

    :before {
        color: #fc0;
        font-family: 'Material Design Icons';
        content: '\\F040A';
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
    }

    :hover {
        background-color: #fc0;
    }

    :hover:before {
        color: #000;
    }

    &.stop {
        border: 1px solid #f44;
    }
    &.stop:before {
        content: '\\F04DB';
        color: #f44;
    }
    &.stop:hover {
        background-color: #f44;
    }
    &.stop:hover:before {
        color: #000;
    }
`;

export const AudioEdit = styled.div`
    width: 30px;
    height: 30px;
    border: 1px solid #09f;
    margin-right: 10px;
    cursor: pointer;
    position: relative;

    :before {
        color: #09f;
        font-family: 'Material Design Icons';
        content: '\\F03EB';
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
    }

    :hover {
        background-color: #09f;
    }
    
    :hover:before {
        color: #000;
    }
`;

export const Player = styled.div`
    height: 243px;
    min-height: 243px;
    overflow: hidden;
    transition: all .4s ease 0s;

    &.compact { 
        height: 54px;
        min-height: 54px;
    }
`;

export const Label = styled.div`
    color: #999;
    font-size: 12px;
    text-transform: uppercase;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
`;

export const Input = styled.input`
    border: 1px solid #555;
    background-color: #111;
    height: 30px;
    padding: 0 5px;
    width: 100%;
    margin-bottom: 10px;
    color: #999;
`;

export const Slider = styled.input`
`;

export const NoMusic = styled.div`
    flex: 1;
    width: 100%;
    color: #666;
    padding: 0 20px;
    text-align: center;
    line-height: 25px;
    font-size: 14px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    &:before {
        font-family: 'Material Design Icons';
        font-size: 150px;
        line-height: 150px;
        margin-top: -30px;
        color: #333;
        content: '\\F0388';
    }
    
`;